import { MatrixRow } from 'pages/trading/price/promotion/PricePromotionDetailPage';
import { MatrixCard } from 'pages/trading/price/promotion/MatrixCard';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { ColumnTitleCard } from 'pages/trading/price/promotion/ColumnTitleCard';

export interface PromotionKpiMatrixRowProperties {
  title: string;
  row: MatrixRow;
  measureUnitCode: MeasureUnitCode;
  priceColumn?: boolean;
}

export function PromotionKpiMatrixColumn({
  title,
  row,
  measureUnitCode,
  priceColumn = false,
}: PromotionKpiMatrixRowProperties) {
  return (
    <div className="flex flex-col col-span-2">
      <ColumnTitleCard title={title} />
      <MatrixCard
        cardDetails={row.before}
        measureUnitCode={measureUnitCode}
        priceColumn={true}
        initialPrice={priceColumn}
      />
      <MatrixCard cardDetails={row.promotion} measureUnitCode={measureUnitCode} priceColumn={priceColumn} />
      <MatrixCard cardDetails={row.after} measureUnitCode={measureUnitCode} priceColumn={priceColumn} isLast />
    </div>
  );
}
